import tw from "twin.macro";

export const SectionHeading = tw.h2 `text-4xl sm:text-5xl text-primary-300 font-black tracking-wide text-center`;
export const Subheading = tw.h3 `font-bold text-primary-500`;